import { Component,OnInit,OnDestroy,AfterViewInit,Input,Output,EventEmitter } from "@angular/core";
import { takeWhile } from "rxjs/operators";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

import {
    FvmsCommonService
    ,FvmsApiCompanyService
} from "src/app/shared/service";
import {
    DtgActionType
} from "src/app/shared/vo";
import {
    DtgManageCompanyModalDeleteComponent
} from "src/app/dtg/manage/company/modal/delete/dtg.manage.company.modal.delete.component";

@Component({
    selector: "dtg-manage-company-tree"
    ,templateUrl: "./dtg.manage.company.tree.component.html"
    ,styleUrls: ["./dtg.manage.company.tree.component.scss"]
    ,providers: []
})
export class DtgManageCompanyTreeComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;
    isOpenChild:boolean = false;
    listCompanyInfo:any[];
    selectedCompanyInfo:any;
    @Input() set nodeInfo(nodeInfo:any){
        let companyEvent = this.fvmsApiCompanyService.getCompanyEvent();
        if(companyEvent){
            this.selectedCompanyInfo = companyEvent.companyInfo;
        }
        if(nodeInfo){
            if(nodeInfo.companyInfo){
                this.companyInfo = nodeInfo.companyInfo;
                if(this.isSelectedCompany() === true){
                    this.isOpenChild = true;
                    this.openParentOut.emit(this.companyInfo.pCompanyId);
                }
                this.reloadListItems();
            }
        }
    }
    @Output() openParentOut:EventEmitter<number> = new EventEmitter(true);

    constructor(
        private fvmsCommonService:FvmsCommonService
        ,private fvmsApiCompanyService:FvmsApiCompanyService
        ,private modalService: NgbModal
    ) {

    }

    ngOnInit() {
        this.fvmsApiCompanyService.subscribeCompanyEvent()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyEvent => {
                // 회사 선택이 변경 되었을때 자회사 목록을 펼쳐준다
                if(companyEvent){
                    this.selectedCompanyInfo = companyEvent.companyInfo;
                }
                if(this.isSelectedCompany() === true){
                    this.isOpenChild = true;
                    this.openParentOut.emit(this.selectedCompanyInfo.pCompanyId);
                }
            });
    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngAfterViewInit() {}

    isSelectedCompany():boolean{
        if(this.selectedCompanyInfo && this.companyInfo){
            return this.selectedCompanyInfo.companyId === this.companyInfo.companyId;
        }
        return false;
    }

    changeIsOpen(){
        this.isOpenChild = !this.isOpenChild;
    }

    reloadListItems(){
        if(this.companyInfo){
            this.fvmsApiCompanyService.getListCompanyTree(this.companyInfo.companyId,"")
                .pipe(takeWhile(() => this.isContinue))
                .subscribe(response => {
                    if(response.resultStatus === "ok"){
                        let tmpList = response.resultValue;
                        this.listCompanyInfo = tmpList.filter((item) => item.companyId !== this.companyInfo.companyId);
                        // console.log("CompanySelectorTreeComponent","reloadListItems",this.listCompanyInfo);
                    }
                });
        }
    }

    clickSelectCompany(){
        let companyEvent = {
            companyInfo:this.companyInfo
            ,DtgActionType:DtgActionType.update
        };
        this.fvmsApiCompanyService.setCompanyEvent(companyEvent);
    }

    changeOpenParentOut(e){
        if(e && e === this.companyInfo.companyId){
            this.isOpenChild = true;
            this.openParentOut.emit(this.companyInfo.pCompanyId);
        }
    }

    clickAddCompanyChild(currentCompanyInfo:any){
        // console.log("clickAddCompanyChild",currentCompanyInfo);
        let companyEvent = {
            companyInfo:currentCompanyInfo
            ,DtgActionType:DtgActionType.create
        };
        this.fvmsApiCompanyService.setCompanyEvent(companyEvent);
    }

    clickRemoveCompany(currentCompanyInfo:any){
        // console.log("clickRemoveCompany",currentCompanyInfo);
        let modalRef = this.modalService.open(
            DtgManageCompanyModalDeleteComponent
            ,{
                centered:true
                ,size: "sm"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }
        );
        modalRef.componentInstance.companyInfo = currentCompanyInfo;

        modalRef.result.then((resultModal) => {
            if(resultModal.result === "ok"){
                this.fvmsApiCompanyService.deleteCompanyInfo(this.companyInfo)
                    .pipe(takeWhile(() => this.isContinue))
                    .subscribe(response => {
                        if(response.resultStatus === "ok"){
                            let companyEvent = {
                                companyInfo:currentCompanyInfo
                                ,DtgActionType:DtgActionType.delete
                            };
                            this.fvmsApiCompanyService.setCompanyEvent(companyEvent);
                        }
                    });
            }
        });
    }
}